import { render } from "./Character_voting.vue?vue&type=template&id=7cfffdd4&scoped=true"
import script from "./Character_voting.vue?vue&type=script&lang=js"
export * from "./Character_voting.vue?vue&type=script&lang=js"

import "./Character_voting.vue?vue&type=style&index=0&id=7cfffdd4&scoped=true&lang=css"

import exportComponent from "/Users/news/Desktop/source/topic_freddy/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cfffdd4"]])